import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form"
import MenuItem from "@mui/material/MenuItem";

const MpgSelect = ({ rhfFormInstance, name, className, label, variant, size, placeholder, sx, disabled, required, onExtraOnchangeHandler, children, width, maxWidth }) => {
    /**Note mui select does not support for placeholder */

    const { control, formState } = rhfFormInstance
    const myStyle = {
        '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: '#f5f5f5',
        },
    }

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={''}
            render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { invalid, isTouched, isDirty, error },
                formState: { errors },
            }) => {

                // console.log("gl-MyMpgSelect:", value)
                return (
                    <TextField
                        id={`${name}-mpg-input`}
                        fullWidth
                        className={!!className ? className : ''}
                        select
                        name={`${name}`}
                        onChange={(e) => {
                            onChange(e)

                            if (!!onExtraOnchangeHandler) {
                                onExtraOnchangeHandler(e)
                            }
                        }}

                        value={value || ''}
                        inputRef={ref}
                        placeholder={'select'}
                        label={label}
                        variant={!!variant ? variant : "outlined"}
                        size={!!size ? size : "large"}
                        sx={[myStyle, sx]}
                        disabled={disabled}
                        required={required}
                        margin="normal"

                        SelectProps={{
                            style: { textAlign: 'left' },
                            MenuProps: {
                                style: {
                                    maxHeight: 300,
                                },
                            }
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}

                        error={!!errors[name]}
                        helperText={errors[name] ? errors[name].message : null}
                    >
                        <MenuItem value=''>None</MenuItem>
                        {children}
                    </TextField >
                )
            }}
        />
    )
}
export default MpgSelect